module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 21h12v-2H10v2zm0-4h12v-2H10v2zm0-6v2h12v-2H10z\"></path></svg>"